import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './EventsWidget.css';
import React, { useContext, useEffect } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import getListing from "../../utils/getListing";
import { commonStyles as EventsCommonStyles } from "../15_Events/Events";
import EventBlock from "../15_Events/components/EventBlock";
import DateRange from "../Listing/DateRange";
import { filtersStylesLtr, filtersStylesRtl } from "../DynamicListingComponent/DynamicListingComponent";
import DropDown from "../Listing/DropDown";
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
var EventsWidget = function EventsWidget(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var lang = sitecoreContext && sitecoreContext.language;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var _fields$data = fields.data,
    interactionWithWidgetAnalytics = _fields$data.interactionWithWidget,
    seeMoreAnalytics = _fields$data.seeMore;
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var title = get(fields, 'data.datasource.widgetTitle.jss.value', 'text');
  var logo = get(fields, 'data.datasource.widgetLogo.jss.value.src', '/');
  var seeMoreText = get(fields, 'data.overviewButton.title.jss.value', 'text');
  var seeMoreURL = get(fields, 'data.overviewButton.link.jss.value.href', 'url');
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    hits = _React$useState4[0],
    setHits = _React$useState4[1];
  var dictionary = get(fields, 'data.dictionary');
  var curatorPick = getDictionaryItem(dictionary, 'Curatorspick');
  var indexes = get(params, 'SearchIndex');
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    selectedDateRange = _React$useState6[0],
    setSelectedDateRange = _React$useState6[1];
  var _React$useState7 = React.useState([]),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    selectedFacets = _React$useState8[0],
    setSelectedFacets = _React$useState8[1];
  var _React$useState9 = React.useState({}),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    defaultFacets = _React$useState10[0],
    setDefaultFacets = _React$useState10[1];
  var _React$useState11 = React.useState({}),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    facets = _React$useState12[0],
    setFacets = _React$useState12[1];
  var _React$useState13 = React.useState(''),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    color = _React$useState14[0],
    setColor = _React$useState14[1];
  var _React$useState15 = React.useState(''),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    grid = _React$useState16[0],
    setGrid = _React$useState16[1];
  var filterWrapperRef = /*#__PURE__*/React.createRef();
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    "--events-widget-primary-color": BackgroundColorHex,
    "--events-widget-primary-active-color": ActiveColorHex,
    "--events-widget-color": ColorHex
  } : {
    "--events-widget-primary-color": selectedPrimaryColor,
    "--events-widget-primary-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--events-widget-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var filters = [{
    "title": {
      "jss": {
        "value": mapDictionary.get('Categories')
      }
    },
    "fieldNameItem": {
      "item": {
        "filedName": {
          "value": "category"
        }
      }
    },
    "fieldTypeItem": {
      "item": {
        "fieldType": {
          "value": "Dropdown Multi Select"
        }
      }
    },
    "tagsToDisplay": {
      "values": []
    }
  }, {
    "title": {
      "jss": {
        "value": mapDictionary.get('Select Date')
      }
    },
    "fieldNameItem": {
      "item": {
        "filedName": {
          "value": "datesRange"
        }
      }
    },
    "fieldTypeItem": {
      "item": {
        "fieldType": {
          "value": "Date Range"
        }
      }
    }
  }];
  var setFilter = function setFilter(date, type, selectedFacets) {
    if (type === 'daterange') {
      setSelectedDateRange(date);
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    } else {
      setSelectedFacets(selectedFacets || []);
    }
    ;
  };
  var filterPanelToggle = function filterPanelToggle(toggle) {
    if (filterWrapperRef.current) {
      if (canUseDOM) {
        if (toggle) {
          document.documentElement.style.overflowY = '';
        } else {
          document.documentElement.style.overflowY = 'hidden';
        }
      }
      if (toggle) {
        filterWrapperRef.current.classList.remove('filter__wrapper--open');
      } else {
        filterWrapperRef.current.classList.add('filter__wrapper--open');
      }
    }
  };
  var loadItems = function loadItems() {
    var urlParams = new URLSearchParams();
    if (canUseDOM) {
      urlParams = new URLSearchParams(document.location.search);
    }
    setColor(urlParams.get('color') || '6E2B62');
    switch (urlParams.get('type')) {
      case 'Horizontal':
        setGrid('col-12 col-md-6');
        break;
      case 'Horizontal Wide':
        setGrid('col-12 col-md-4');
        break;
      case 'Horizontal Double Rows':
        setGrid('col-12 col-md-4');
        break;
      default:
        setGrid('col-12');
    }
    var getCountPerPage = function getCountPerPage() {
      var counts = {
        'Horizontal': 2,
        'Horizontal Wide': 3,
        'Horizontal Double Rows': 6
      };
      var urlType = urlParams.get('type');
      if (urlType in counts) {
        // @ts-ignore
        return counts[urlType];
      }
      return 3;
    };
    var itemFilters = {
      facets: ["datesRange", "category", "tags"],
      facetFilters: [["type:Event"]],
      hitsPerPage: getCountPerPage(),
      page: 0
    };
    if (selectedDateRange) {
      itemFilters.filters = selectedDateRange;
    }
    if (selectedFacets.length) {
      itemFilters.facetFilters.push(selectedFacets.map(function (facet) {
        return "category:".concat(facet);
      }));
    }
    getListing(indexes, itemFilters).then(function (response) {
      if (!Object.keys(defaultFacets).length) {
        setDefaultFacets(response.facets);
      }
      if (!facets.category) {
        setFacets(response.facets);
      }
      setHits(response.hits);
    });
  };
  var locationSearch = '';
  if (canUseDOM) {
    locationSearch = document.location.search;
  }
  useEffect(loadItems, [selectedFacets, selectedDateRange, locationSearch]);
  if (!fields) {
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[EventsWidget component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "e-widget ",
    style: _objectSpread(_objectSpread({}, variables), {
      '--widget-iframe-color': "#".concat(color),
      '--date-range-primary-color': "#".concat(color)
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "e-widget__header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h3 e-widget__title"
  }, title), /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: title,
    className: "e-widget__logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "e-widget__nav",
    ref: filterWrapperRef,
    style: {
      backgroundColor: "#".concat(color)
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-back-link"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "header back",
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8cGF0aCBmaWxsPSIjMDA3Q0JBIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik03LjcxMiA0YTIuMTQgMi4xNCAwIDAgMS0uMjg0IDIuOTI3TDQuOTk2IDkuMDQ1SDE5djEuOTEzSDQuOTk2bDIuNDMyIDIuMTE2Yy44NTcuNzQ1Ljk4MSAyLjAzLjI4NCAyLjkyNkwxIDEwbDYuNzEyLTZ6Ii8+DQo8L3N2Zz4NCg=="
  })), /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-links filter__header-cancel-btn",
    onClick: function onClick(e) {
      filterPanelToggle(e);
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, mapDictionary.get('Cancel'))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header-text body-medium",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("span", null, mapDictionary.get('Filters')))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filters.map(function (filter) {
    var fieldNameItem = filter.fieldNameItem.item.filedName.value;
    var filterFacets = facets[fieldNameItem];
    var defaultFilterFacets = defaultFacets[fieldNameItem];
    switch (fieldNameItem) {
      case 'category':
        {
          return /*#__PURE__*/React.createElement(DropDown, {
            fields: filter,
            openWithWrapper: true,
            buttonYellow: true,
            clearAllLabel: mapDictionary.get('Clear All'),
            clearAlllFilters: true,
            widgetAnalytics: true,
            hideAmount: true,
            showLabel: mapDictionary.get('Show'),
            resultsLabel: mapDictionary.get('Results'),
            facets: filterFacets,
            facetsName: fieldNameItem,
            defaultFacets: defaultFilterFacets,
            firstFilter: true,
            nbHits: hits.length,
            firstQuery: '',
            onChangeCallback: function onChangeCallback() {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            onToggleCallback: function onToggleCallback() {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            indexDropDown: 0,
            setFilter: setFilter,
            wrapperToggle: filterPanelToggle,
            setSubpanelLabel: function setSubpanelLabel() {},
            analytics: {},
            primaryColor: selectedPrimaryColor,
            resetAllFiltersCallback: function resetAllFiltersCallback() {}
          });
        }
      case 'eventDatesRange':
        {
          return /*#__PURE__*/React.createElement(DateRange, {
            hideLabel: true,
            clearAllLabel: mapDictionary.get('Clear All'),
            clearAlllFilters: true,
            clearWithCloseWrapper: true,
            buttonYellow: true,
            widgetAnalytics: true,
            fields: filter,
            clearAllCallback: function clearAllCallback() {},
            innerHeightAuto: true,
            showButtonColor: "var(--widget-iframe-color, var(--events-widget-primary-color))",
            showLabel: mapDictionary.get('Show'),
            resultsLabel: mapDictionary.get('Results'),
            facetsName: ['datesRange.from', 'datesRange.to'],
            setFilter: setFilter,
            onChangeCallback: function onChangeCallback() {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            onToggleCallback: function onToggleCallback() {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            wrapperToggle: filterPanelToggle,
            setSubpanelLabel: function setSubpanelLabel() {},
            analytics: {
              filterSelectDateAnalytics: interactionWithWidgetAnalytics,
              params: params
            },
            lang: lang,
            primaryColor: selectedPrimaryColor
          });
        }
    }
  }).map(function (children) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-md-4 e-widget__filter"
    }, children);
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-4 e-widget__mobile-show",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary"
  }, mapDictionary.get('Show'), " ", mapDictionary.get('Results'))))), /*#__PURE__*/React.createElement("div", {
    className: "e-widget__body row",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, hits.map(function (hit) {
    return /*#__PURE__*/React.createElement("div", {
      className: grid
    }, /*#__PURE__*/React.createElement(EventBlock, {
      key: hit.objectID,
      event: hit,
      widgetAnalytics: true,
      curatorsCopy: curatorPick,
      lang: lang,
      linksTarget: "_PARENT",
      removeFavButton: true,
      hostLink: '',
      analytics: {
        eventsAnalytics: eventsAnalytics,
        params: params
      },
      multipleDates: mapDictionary.get('multipleDates'),
      countryItems: countryItems,
      themeValues: [Object.values(variables)[0], Object.values(variables)[2]]
    }));
  })), seeMoreURL && hits.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "e-widget__see-more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "see-more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn btn-link see-more__link-desktop",
    "aria-label": "See More",
    "aria-labelledby": "See More",
    target: "_PARENT",
    rel: "noopener noreferrer",
    href: seeMoreURL,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(seeMoreAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-link__text"
  }, seeMoreText), /*#__PURE__*/React.createElement("svg", {
    className: "btn-link__icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--events-widget-primary-color)",
    fillRule: "nonzero",
    d: "M8.394 5.5L13 10l-4.606 4.5a1.904 1.904 0 0 1 0-2.724L10.212 10 8.394 8.224a1.904 1.904 0 0 1 0-2.724z"
  }))))), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-link see-more__link-mobile",
    target: "_PARENT",
    "aria-label": "See More",
    "aria-labelledby": "See More",
    rel: "noopener noreferrer",
    href: seeMoreURL,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(seeMoreAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn btn-primary"
  }, seeMoreText))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(EventsCommonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(rtl ? filtersStylesRtl : filtersStylesLtr, " ").concat(className, "  "),
    "data-cy": "rich-text"
  }, children);
};
var commonStyles = "cuif8y4";
var ltrStyles = "l17qkqnn";
var rtlStyles = "rbr3l82";
export default EventsWidget;